module.exports = {"371002001":"环翠楼街道","371002002":"鲸园街道","371002003":"竹岛街道","371002011":"孙家疃街道","371002100":"张村镇","371002101":"羊亭镇","371002102":"温泉镇","371002400":"嵩山街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371002.json
// module id = 1331
// module chunks = 0